import React from 'react'

import HoverTooltip from '../../../../components/HoverTooltip'
import RegistryPeriodSelect from './RegistryPeriodSelect'
import { PurchaseCountAndSum } from '../types'

type Props = {
    theme: string
    yearPeriod: number | null
    onYearPeriodChange: (value: number | null) => void
    purchaseCountAndSum: PurchaseCountAndSum | null
    loadingCountSum?: boolean
}

const PurchaseHeader: React.FC<Props> = ({
    theme,
    yearPeriod,
    onYearPeriodChange,
    purchaseCountAndSum,
    loadingCountSum = false,
}) => {
    const fmt = (n: number | undefined) =>
        typeof n === 'number' ? n.toLocaleString('ru-RU') : 'Нет данных'

    return (
        <div className=" h-24 mx-6 flex flex-row gap-x-5">
            <div className="w-44 my-auto content-center border-r border-r-[#b8b8b8] dark:border-r-[#2A282B]">
                <div className="text-xs text-[#6A6A6A] dark:text-[#8A8A8A] ">
                    Период реестра
                </div>
                <RegistryPeriodSelect
                    startYear={new Date().getFullYear()}
                    endYear={2018}
                    value={
                        yearPeriod === null
                            ? 'all'
                            : (String(yearPeriod) as `${number}`)
                    }
                    onChange={(v) =>
                        onYearPeriodChange(v === 'all' ? null : Number(v))
                    }
                />
            </div>
        </div>
    )
}

export default PurchaseHeader
